// Global UI feature switches.
// Set to false to return platform navigation back to the header.
export const ENABLE_PLATFORM_SIDEBAR = true;

export const UI_FEATURE_FLAGS = {
  platformSidebar: ENABLE_PLATFORM_SIDEBAR,
} as const;
